import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './dentist_v2/Header';
import Footer from './dentist_v2/Footer';
import Home from './dentist_v2/Home';
import Treatments from './dentist_v2/Treatments';
import Team from './dentist_v2/Team';
import Book from './dentist_v2/Book';

export default function DentistTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F8FAFB]" data-testid="dent-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`dent-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'treatments' && <Treatments setPage={setPage} />}
          {page === 'team' && <Team setPage={setPage} />}
          {page === 'book' && <Book setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
